<template>
  <AbstractServiceDetailsModal :value="value" v-on="$listeners" :headingText="currentServiceItem.heading">
    <component
      :is="currentServiceItem.form"
      :type="serviceType"
      :entity="entity"
      :isAddMode="isAddMode"
      :company="company"
      @submit="$emit('close')"
      @editExistingServiceItem="$emit('editExistingServiceItem', $event)"
      @addServiceItem="$emit('addServiceItem', $event)"
      @downloadFile="$emit('downloadFile', $event)"
    ></component>
  </AbstractServiceDetailsModal>
</template>

<script>
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';
import AbstractServiceDetailsModal from './abstract-service-details-modal';
import SupplementingMaterials from './forms/supplementing-materials';
import RollingStockService from './forms/rolling-stock-service';
import LocomotiveWashing from './forms/locomotive-washing';
import LocomotiveControlReview from './forms/locomotive-control-review';
import TrainCleaning from './forms/train-cleaning';
import CargoCorrection from './forms/cargo-correction';

const detailsMap = {
  [SERVICE_TYPE_DICT.SUPPLEMENTING_MATERIALS]: {
    heading: 'Uzupełnienie materiałów eksploatacyjnych',
    form: SupplementingMaterials,
  },
  [SERVICE_TYPE_DICT.FLEET_SERVICE]: {
    heading: 'Serwis taboru',
    form: RollingStockService,
  },
  [SERVICE_TYPE_DICT.LOCOMOTIVE_WASHING]: {
    heading: 'Mycie lokomotywy',
    form: LocomotiveWashing,
  },
  [SERVICE_TYPE_DICT.REVIEW_P1]: {
    heading: 'Przegląd lokomotywy (P1)',
    form: LocomotiveControlReview,
  },
  [SERVICE_TYPE_DICT.REVIEW_P2]: {
    heading: 'Przegląd lokomotywy (P2)',
    form: LocomotiveControlReview,
  },
  [SERVICE_TYPE_DICT.REVIEW_P3]: {
    heading: 'Przegląd lokomotywy (P3)',
    form: LocomotiveControlReview,
  },
  [SERVICE_TYPE_DICT.TRAIN_CLEANING]: {
    heading: 'Sprzątanie składu',
    form: TrainCleaning,
  },
  [SERVICE_TYPE_DICT.CARGO_CORRECTION]: {
    heading: 'Korekta ładunku',
    form: CargoCorrection,
  },
};

export default {
  name: 'ServiceDetailsModal',
  components: {
    AbstractServiceDetailsModal,
  },
  props: {
    serviceItem: {
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    isCoursePreview: {
      type: Boolean,
      default: false,
    },
    isAddMode: {
      type: Boolean,
      default: false,
    },
    company: Object,
  },
  computed: {
    currentServiceItem() {
      return this.value ? detailsMap[this.serviceItem.serviceType] : { heading: '', form: null };
    },
    serviceType() {
      return this.value ? this.serviceItem.serviceType : null;
    },
    entity() {
      return this.isCoursePreview ? this.serviceItem : null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
